import { render, staticRenderFns } from "./StudyQuizQuestionWelcome.vue?vue&type=template&id=e4f1514c"
import script from "./StudyQuizQuestionWelcome.vue?vue&type=script&lang=js"
export * from "./StudyQuizQuestionWelcome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports